import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import RequireAuth from './components/RequireAuth';
import { ToastProvider } from './components/Toast';
import { AuthProvider } from './contexts/AuthContext';
import { StepUpProvider } from './contexts/StepUpContext';
import ConsentExpiryWarning from './components/ConsentExpiryWarning';
import NewVersionBanner from './components/NewVersionBanner';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Documents from './pages/Documents';
import Statements from './pages/Statements';
// Partnerek modul (2026-09-16, F1) — a lista és a route-olt részletpanel egy oldalon;
// a `/partners/:pid` mélylinkelhető (a Bizonylatok `/documents/:docId` mintájára).
import Partners from './pages/Partners';
import { Stats, Accountant, Settings, Domains } from './pages/misc';
// NAV egyeztetés — az „Információk" menü alatt (Gábor döntése, 2026-08-04):
// nem statisztika és nem a Bizonylatok oldalra való, hanem teendő-lista.
import NavReconcile from './pages/NavReconcile';
// A NAV-tol jovo adofolyoszamla MEGTEKINTESE (nem osszevetes) — kulon oldal,
// mert az egyeztetes csak az ELTERESEKET mutatja.
import NavTaxAccount from './pages/NavTaxAccount';

export default function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login/>}/>
          <Route path="/*" element={
            <RequireAuth>
              {/* A step-up ablak a bejelentkezett részfán belül él: a
                  `requireStepUp()` csak hitelesített felhasználónak értelmes. */}
              <StepUpProvider>
              {/* Raiffeisen consent-lejárat: naponta egyszer leokézandó modal.
                  A bejelentkezett részfán belül van, mert hitelesített hívást tesz. */}
              <ConsentExpiryWarning/>
              {/* Deploy után a régi lap csendben a régi kóddal futna (2026-09-24). */}
              <NewVersionBanner/>
              <Layout>
                <Routes>
                  <Route path="/"           element={<Dashboard/>}/>
                  <Route path="/documents"  element={<Documents/>}/>
                  <Route path="/documents/:docId" element={<Documents/>}/>
                  <Route path="/statements" element={<Statements/>}/>
                  <Route path="/partners"      element={<Partners/>}/>
                  <Route path="/partners/:pid" element={<Partners/>}/>
                  <Route path="/accountant" element={<Accountant/>}/>
                  <Route path="/stats"      element={<Stats/>}/>
                  <Route path="/info/nav-adofolyoszamla" element={<NavTaxAccount/>}/>
                  <Route path="/info/nav-egyeztetes" element={<NavReconcile/>}/>
                  <Route path="/domains"    element={<Domains/>}/>
                  <Route path="/settings"          element={<Settings/>}/>
                  <Route path="/settings/:group"   element={<Settings/>}/>
                </Routes>
              </Layout>
              </StepUpProvider>
            </RequireAuth>
          }/>
        </Routes>
      </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}
